import styled from "styled-components";

export const BalanceValuePrimaryDefaultBox = styled.span`
    font-size: 2rem;
    font-weight: 700;
    color: ${({theme}) => theme.colors.moneyColor};
    margin: 0.7rem 0 0.8rem 0;
`;

